import reportApi from "@/api/report";
import { objectFromFlatAnswers } from "@/shared/helpers"

interface Report {
  generalInformation: any[],
  userAnswers: any[]
}

interface IReportState {
  reports: any[],
  reportsError: object,
  report: Report,
  reportError: object,
  branches: object,
  branchesError: object,
}

const state:IReportState = {
  reports: [],
  reportsError: {},
  report: {} as Report,
  reportError: {},
  branches: {},
  branchesError: {},
};

const getters = {
  getReports: (state:IReportState, getters:object) => state.reports,
  getReport: (state:IReportState, getters:any) => state.report,
  getBranches: (state:IReportState, getters:object) => state.branches,
  getSummary: (state:IReportState, getters:object) => state.report,
};

const actions = {
  async fetchReports({ commit }:{commit: Function}) {
    commit("setReports", null);

    try {
      const {data} = await reportApi.getReports();

      const returnData = data.map(e => ({
        ...e,
        liquidationValue: parseInt(e.liquidationValue, 0),
        nnv: parseInt(e.nnv, 0),
        maxScore: parseInt(e.maxScore, 0),
        summaryScore: parseInt(e.summaryScore, 0)
      }));

      commit("setReports", returnData);
    } catch (e) {
      commit("setReportsError", e);
    }
  },

  async fetchReport({ commit }:{commit: Function}, reportId: string) {
    commit("setReport", null);

    try {
      const {data} =  await reportApi.getReport(reportId);

      const structured = {
        ...data,
        userAnswers: objectFromFlatAnswers(data.userAnswers)
      }

      commit("setReport", structured);
    } catch(e) {
      commit("setReportError");
    }
  }
};

const mutations = {
  setReports: (state:IReportState, reports:any) => state.reports = reports,
  setReportsError: (state:IReportState, error:any) => state.reportsError = error,
  setReport: (state:IReportState, report:any) => state.report = report,
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
